'use client'

import React from 'react'
import Link from 'next/link'
import type { Locale } from '@/i18n'
import { cn } from '@/utilities/ui'
import { useApplicationModalStore } from '@/stores/applicationModalStore'

interface DualCTAProps {
  locale: Locale
  className?: string
}

export function DualCTA({ locale, className }: DualCTAProps) {
  const { openModal } = useApplicationModalStore()

  const t = {
    uk: {
      join: 'Приєднатися',
      vacancies: 'Вакансії',
    },
    en: {
      join: 'Apply Now',
      vacancies: 'Vacancies',
    },
  }[locale]

  return (
    <>
      {/* Mobile Sticky CTA - Single Button */}
      <div
        className={cn(
          'fixed bottom-0 left-0 right-0 md:hidden z-[100]',
          'bg-background border-t border-border p-4',
          className,
        )}
      >
        <button
          onClick={() => openModal()}
          className="inline-flex items-center justify-center px-6 py-3 bg-primary text-white rounded-full md:rounded-lg hover:bg-primary/90 transition-colors text-lg font-medium w-full"
        >
          {t.join}
        </button>
      </div>

      {/* Desktop Sticky CTA Bar - Dual Buttons */}
      <div className="hidden md:block sticky bottom-0 left-0 right-0 z-[100] bg-background py-4 mt-8">
        <div className="container max-w-[774px] px-2">
          <div className="flex gap-4 justify-center">
            <button
              onClick={() => openModal()}
              className="flex-1 inline-flex items-center justify-center px-8 py-4 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors text-lg font-medium"
            >
              {t.join}
            </button>
            <Link
              href={`/${locale}/vacancies`}
              className="flex-1 inline-flex items-center justify-center px-8 py-4 bg-background border-2 border-primary text-primary rounded-lg hover:bg-primary hover:text-white transition-colors text-lg font-medium"
            >
              {t.vacancies}
            </Link>
          </div>
        </div>
      </div>

      {/* Spacer for mobile only */}
      <div className="md:hidden h-20" />
    </>
  )
}
